import { connect } from 'react-redux';
import { ICardAssigneesDropdownHOCProps } from './types';
import { IApplicationState } from '../../../../../../../../types/types';
import { onSelect } from './events/onSelect';
import {
    getAssigneesSearchSelectOptionsCreateSelector
} from '../../../../../../aside_panel/cardDetails/AssigneesSection/hocs/AssigneesSearchSelectHOC/selectors/getAssigneesSearchSelectOptions';
import {
    ASSIGNEE_GROUP_DIVIDER,
    ASSIGNEE_GROUP_TITLE
} from '../../../../../../aside_panel/cardDetails/AssigneesSection/components/constants';
import {
    ICardAssigneesDropdownEvents,
    ICardAssigneesDropdownFields
} from '../../components/CardAssigneesDropdown/types';
import { CardAssigneesDropdown } from '../../components/CardAssigneesDropdown/CardAssigneesDropdown';

const mapStateToProps = () => {
    const getAssigneesSearchSelectOptions = getAssigneesSearchSelectOptionsCreateSelector();

    const _mapStateToProps = (
        state: IApplicationState,
        { cardId, boardId, listId, assignees, directionVertical }: ICardAssigneesDropdownHOCProps
    ): ICardAssigneesDropdownFields => {
        if (cardId) {
            return {
                directionVertical,
                cardId,
                searchSelectOptions: getAssigneesSearchSelectOptions(state, boardId, [cardId])
            };
        } else {
            const searchSelectOptions = getAssigneesSearchSelectOptions(state, boardId, []).map((item) => {
                if (item.value === ASSIGNEE_GROUP_TITLE || item.value === ASSIGNEE_GROUP_DIVIDER) {
                    return {
                        ...item,
                        options: item.options.map((user) => {
                            return {
                                ...user,
                                active: assignees.includes(item.value)
                            };
                        })
                    };
                } else {
                    return {
                        ...item,
                        active: assignees.includes(item.value)
                    };
                }
            });
            return {
                directionVertical,
                listId,
                searchSelectOptions
            };
        }
    };

    return _mapStateToProps;
};

const mapDispatchToProps = (
    dispatch: any,
    { boardId, cardId, onClosed, assignees, source, onChange }: ICardAssigneesDropdownHOCProps,
): ICardAssigneesDropdownEvents => {
    return {
        onToggle: (permissionId) => dispatch(onSelect(boardId, cardId, permissionId, source, assignees, onChange)),
        onClosed,
    }
};

export const CardAssigneesDropdownHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(CardAssigneesDropdown);

CardAssigneesDropdownHOC.displayName = 'CardAssigneesDropdownHOC';
